import { createAuthClient } from "better-auth/react"
import { organizationClient } from "better-auth/client/plugins"
import { betterAuthUrl } from "../config"
import { admin } from "better-auth/plugins/admin"
import { bearer } from "better-auth/plugins/bearer"

export const authClient = createAuthClient({
  baseURL: betterAuthUrl,
  basePath: "/auth",
  plugins: [bearer(), admin(), organizationClient()],
  fetchOptions: {
    onSuccess: (ctx) => {
      const authToken = ctx.response.headers.get("set-auth-token") // get the token from the response headers
      // Store the token securely (e.g., in localStorage)
      if (authToken) {
        localStorage.setItem("bearer_token", authToken)
      }
    },
    auth: {
      type: "Bearer",
      token: () => localStorage.getItem("bearer_token") || "", // get the token from localStorage
    },
  },
})

// Export organization-specific methods for easier access
// Note: Active organization and organization list are managed via user preferences in GraphQL
// Only use better-auth for organization mutations (create, update, delete, invite, etc.)
export const {
  organization: {
    // Admin-only operations
    create: createOrganization,
    checkSlug,
    update: updateOrganization,
    delete: deleteOrganization,

    // Member operations
    inviteMember,
    cancelInvitation,
    acceptInvitation,
    rejectInvitation,
    getInvitation,
    listInvitations,
    listUserInvitations,
    listMembers,
    removeMember,
    updateMemberRole,
    getActiveMember,
    getActiveMemberRole,
    leave: leaveOrganization,

    // Organization details (for admin use)
    getFullOrganization,
  },
} = authClient

// Export the full organization client for admin access to all methods
export const organization = authClient.organization
